import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Pipe({
  name: 'secureProfilePic',
  standalone: false
})
export class SecureProfilePicPipe implements PipeTransform {

  defaultUserIcon = '/assets/default-user-image.png';
  constructor(
    private readonly http: HttpClient,
    private readonly sanitizer: DomSanitizer
  ) { }

  transform(url: string): Observable<SafeUrl> {
    return this.http.get(url, { responseType: 'blob', observe: 'response', params: { 'suppress-aci': 'true' } }
    ).pipe(
      map((res: any) => {
        return this.sanitizer.bypassSecurityTrustStyle(`url(${URL.createObjectURL(res.body)}), url(${this.defaultUserIcon})`);
      }),
      catchError(() => {
        return of(this.sanitizer.bypassSecurityTrustStyle(`url(${this.defaultUserIcon})`));
      })
    );
  }
}